import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "employeeId"]

  open(event) {
    event.preventDefault()
    this.employeeIdTarget.value = event.currentTarget.dataset.employeeId || ""
    this.modalTarget.classList.remove("hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.employeeIdTarget.value = ""
  }
}
